import type { PageViewProps } from './types';
import { useTracktor } from './useTracktor';

export function PageView({ pageViewData }: PageViewProps) {
	useTracktor({ pageViewData });

	return null;
}
